import type { StepInputRendererProps } from "./StepInputRenderer";

import { cn } from "@homeinstead/ui";
import { Link } from "@homeinstead/ui/components/Link";
import { useLocale } from "~www/components/LocaleProvider";
import { resolveTextSizeClass } from "./form-item-styles";

export function PrivacyDisclaimerFormItem({ input }: StepInputRendererProps) {
  const locale = useLocale();
  const siteUrl = locale.metadata.canonicalOrigin;

  if (input._type !== "privacyDisclaimer") {
    return null;
  }

  const sizeClass = resolveTextSizeClass(input.textSize);

  return (
    <p className={cn("text-center leading-relaxed", sizeClass)}>
      By clicking &quot;Contact me with care options&quot; you agree to our{" "}
      <Link
        className={sizeClass}
        href={`${siteUrl}/legal/client-notice-of-privacy-practices`}
        rel="noopener noreferrer"
        size="inline"
        target="_blank"
        variant="plain"
      >
        Privacy Policy
      </Link>
      .
    </p>
  );
}
